import { render } from "./ui-days.vue?vue&type=template&id=658ce624&ts=true"
import script from "./ui-days.vue?vue&type=script&lang=ts"
export * from "./ui-days.vue?vue&type=script&lang=ts"

import "./ui-days.vue?vue&type=style&index=0&id=658ce624&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__